module.exports = __webpack_public_path__ + "img/Frontiers_in_microbiology_cover.cdf60bed.jpg";